import { render, staticRenderFns } from "./CompanySignersSection.vue?vue&type=template&id=651b70cd"
import script from "./CompanySignersSection.vue?vue&type=script&lang=js"
export * from "./CompanySignersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports